<template>

  <div class="container">
    <form @submit.prevent="submit" novalidate v-if="generalInfoStatus">
      <fieldset>
        <h3 class="main-title">Información personal</h3>
        <div class="row row-responsive">
          <div class="column column-xs-100 column-sm-50">
            <label for="name" :class="{'error-text': endpointErrors.name}">Nombre(s):</label>
            <input type="text" name="name" v-model.trim="$v.userInteraction.name.$model" :class="{ 'error-label': $v.userInteraction.name.$error  || endpointErrors.name }" placeholder="Nombre">
            <p class="error" v-if="errors">
              <span v-if="!$v.userInteraction.name.required">El nombre es obligatorio</span>
              <span v-if="!$v.userInteraction.name.minLength">El nombre debe de tener más de 2 letras</span>
              <span v-if="!$v.userInteraction.name.validateName">El nombre no debe contener números ni caracteres especiales</span>
            </p>
          </div>
          <div class="column column-xs-100 column-sm-50">
            <label for="middleName" :class="{'error-text': endpointErrors.middle_name}">Apellido paterno:</label>
            <input type="text" name="middleName" v-model.trim="$v.userInteraction.middleName.$model" :class="{ 'error-label': $v.userInteraction.middleName.$error  || endpointErrors.middle_name }" placeholder="Apellido paterno">
            <p class="error" v-if="errors">
              <span v-if="!$v.userInteraction.middleName.required">El apellido paterno es obligatorio</span>
              <span v-if="!$v.userInteraction.middleName.minLength">El apellido paterno debe de tener más de 2 letras</span>
              <span v-if="!$v.userInteraction.middleName.validateName">El apellido paterno no debe contener números ni caracteres especiales</span>
            </p>
          </div>
        </div>
        <div class="row row-responsive">
          <div class="column column-xs-100 column-sm-50">
            <label for="lastName" :class="{'error-text': endpointErrors.last_name}">Apellido materno:</label>
            <input type="text" name="lastName" v-model.trim="$v.userInteraction.lastName.$model" :class="{ 'error-label': $v.userInteraction.lastName.$error || endpointErrors.last_name }" placeholder="Apellido materno">
            <p class="error" v-if="errors">
              <span v-if="!$v.userInteraction.lastName.required">El apellido materno es obligatorio</span>
              <span v-if="!$v.userInteraction.lastName.minLength">El apellido materno debe de tener más de 2 letras</span>
              <span v-if="!$v.userInteraction.lastName.validateName">El apellido materno no debe contener números ni caracteres especiales</span>
            </p>
          </div>
          <div class="column column-xs-100 column-sm-50">
            <label for="birthDate" :class="{'error-text': endpointErrors.birthdate}">Fecha de nacimiento:</label>
            <DatePicker
              name="birthDate"
              v-model.trim="$v.userInteraction.birthDate.$model"
              :format="dateFormat"
              :monday-first="true"
              :language="es"
              :disabled-dates="{from: new Date(), to: new Date(1900, 0, 0)}"
              :class="{ 'error-label': $v.userInteraction.birthDate.$error ||
                endpointErrors.birthdate }"
              placeholder="Fecha de nacimiento (dd-mm-aaaa)">
            </DatePicker>
            <p class="error" v-if="errors">
              <span v-if="!$v.userInteraction.birthDate.required">
                La fecha de nacimiento es obligatoria
              </span>
              <span v-if="!$v.userInteraction.birthDate.maxLength">
                La fecha de nacimiento no debe tener más de 10 caracteres
              </span>
              <span v-if="!$v.userInteraction.birthDate.adult">
                Debes de ser mayor de 18 años para registrarte
              </span>
              <span v-if="!$v.userInteraction.birthDate.formattedDate">
                El formato de fecha debe ser: dd-mm-aaaa
              </span>
            </p>
          </div>
        </div>
        <div class="row row-responsive">
          <div class="column column-xs-100 column-sm-50">
            <label for="birthCountry" :class="{'error-text': endpointErrors.birthplace}">País de nacimiento:</label>
            <span class="select">
              <select v-model.trim="$v.userInteraction.birthCountry.$model" :class="{ 'error-label': $v.userInteraction.birthCountry.$error || endpointErrors.birthplace }" @change="onCountryChange()">
              <option value="" disabled selected>Seleccione:</option>
              <option v-for="country in countries" :key="country.pk" :value="country.pk">
                {{ country.name }}
              </option>
              </select>
            <span class="arrow"></span>
            </span>
            <p class="error" v-if="errors">
              <span v-if="!$v.userInteraction.birthCountry.required">El país de nacimiento es obligatorio</span>
            </p>
          </div>
          <div class="column column-xs-100 column-sm-50">
            <label for="birthEntity" :class="{'error-text': endpointErrors.birthplace_state}">Estado de nacimiento:</label>
            <span class="select">
              <select v-model.trim="$v.userInteraction.birthEntity.$model" :disabled="!stateStatus" :class="{ 'error-label': $v.userInteraction.birthEntity.$error || endpointErrors.birthplace_state }">
                <option value="" disabled selected>Seleccione:</option>
                <option v-for="state in states" :key="state.pk" :value="state.pk">
                  {{ state.name }}
                </option>
              </select>
              <span class="arrow"></span>
            </span>
            <p class="error" v-if="errors">
              <span v-if="!$v.userInteraction.birthEntity.required">El estado de nacimiento es obligatorio</span>
            </p>
          </div>
        </div>
        <div class="row row-responsive">
          <div class="column column-xs-100 column-sm-50">
            <label for="nationality" :class="{'error-text': endpointErrors.nationality}">Nacionalidad:</label>
            <span class="select">
              <select v-model.trim="$v.userInteraction.nationality.$model" :class="{ 'error-label': $v.userInteraction.nationality.$error || endpointErrors.nationality }">
                <option value="" disabled selected>Seleccione:</option>
                <option v-for="country in countries" :key="country.pk" :value="country.pk">
                  {{ country.name }}
                </option>
              </select>
              <span class="arrow"></span>
            </span>
            <p class="error" v-if="errors">
              <span v-if="!$v.userInteraction.nationality.required">La nacionalidad es obligatoria</span>
            </p>
          </div>
          <div class="column column-xs-100 column-sm-50">
            <label for="gender" :class="{'error-text': endpointErrors.gender}">Género:</label>
            <span class="select">
              <select v-model.trim="$v.userInteraction.gender.$model" :class="{ 'error-label': $v.userInteraction.gender.$error || endpointErrors.gender }">
                <option value="" disabled selected>Seleccione:</option>
                <option v-for="gender in genders" :key="gender.pk" :value="gender.pk">
                  {{ gender.name }}
                </option>
              </select>
              <span class="arrow"></span>
            </span>
            <p class="error" v-if="errors">
              <span v-if="!$v.userInteraction.gender.required">El género es obligatorio</span>
            </p>
          </div>
        </div>
        <div class="row">
          <div class="column">
            <p class="warning">
              <img src="https://icongr.am/clarity/info-standard.svg?size=20&color=00ba68">
              <b>Si no recuerdas puedes encontrar tu <a href=" https://www.sat.gob.mx/tramites/operacion/28753/obten-tu-rfc-con-la-clave-unica-de-registro-de-poblacion-(curp)" target="_blank">RFC</a> y <a href="https://www.gob.mx/curp/" target="_blank">CURP</a> en línea.</b>
            </p>
          </div>
        </div>
        <div class="row row-responsive">
          <div class="column column-xs-100 column-sm-50">
            <label for="rfc" :class="{'error-text': endpointErrors.rfc}">*RFC:</label>
            <input type="text" name="rfc" v-model.trim="$v.userInteraction.rfc.$model" :class="{ 'error-label': $v.userInteraction.rfc.$error || endpointErrors.rfc }" placeholder="RFC">
            <p class="error" v-if="errors">
              <span v-if="!$v.userInteraction.rfc.required">El RFC es obligatorio</span>
              <span v-if="!$v.userInteraction.rfc.minLength">El RFC debe de ser mínimo de 12 caracteres</span>
              <span v-if="!$v.userInteraction.rfc.maxLength">El RFC debe de ser máximo de 13 caracteres</span>
              <span v-if="!$v.userInteraction.rfc.alphaNum">El RFC de ser alfa numérico</span>
              <span v-if="!$v.userInteraction.rfc.rfcCorrect">El formato de RFC es incorrecto</span>
            </p>
            <p class="rfc-message" v-else>
              <span><b>*El RFC es sumamente imporante para validar tu cuenta.</b></span>
            </p>
            <p class="error" v-if="endpointErrors.rfc">
              <span> {{ endpointErrors.rfcTextError }} </span>
            </p>
          </div>
          <div class="column column-xs-100 column-sm-50">
            <label for="curp" :class="{'error-text': endpointErrors.curp}">CURP:</label>
            <input type="text" name="curp" v-model.trim="$v.userInteraction.curp.$model" :class="{ 'error-label': $v.userInteraction.curp.$error || endpointErrors.curp }" placeholder="CURP">
            <p class="error" v-if="errors">
              <span v-if="!$v.userInteraction.curp.required">El CURP es obligatorio</span>
              <span v-if="!$v.userInteraction.curp.minLength">El CURP debe de ser mínimo de 18 caracteres</span>
              <span v-if="!$v.userInteraction.curp.maxLength">El CURP debe de ser máximo de 18 caracteres</span>
              <span v-if="!$v.userInteraction.curp.alphaNum">El CURP de ser alfa numérico</span>
              <span v-if="!$v.userInteraction.curp.curpCorrect">El formato de CURP es incorrecto</span>
            </p>
            <p class="error" v-if="endpointErrors.curp">
              <span> {{ endpointErrors.curpTextError }} </span>
            </p>
          </div>
        </div>
        <div class="row row-responsive">
          <div class="column column-xs-100 column-sm-50">
            <label for="married" :class="{'error-text': endpointErrors.married}">Estado civil:</label>
            <span class="select">
              <select v-model.trim="$v.userInteraction.married.$model" :class="{ 'error-label': $v.userInteraction.married.$error || endpointErrors.married }">
                <option value="" disabled selected>Seleccione:</option>
                <option v-for="status in selectBooleanValues" :key="status.civilStatus" :value="status.value">
                  {{ status.civilStatus }}
                </option>
              </select>
              <span class="arrow"></span>
            </span>
            <p class="error" v-if="errors">
              <span v-if="!$v.userInteraction.married.required">El estado civil es obligatorio</span>
            </p>
          </div>
          <div class="column column-xs-100 column-sm-50">
            <label for="phone" :class="{'error-text': endpointErrors.phone}">Teléfono celular (10 dígitos):</label>
            <input type="text" name="phone" v-model.trim="$v.userInteraction.phone.$model" :class="{ 'error-label': $v.userInteraction.phone.$error || endpointErrors.phone }" placeholder="5512395847">
            <p class="error" v-if="errors">
              <span v-if="!$v.userInteraction.phone.required">El teléfono celular es obligatorio</span>
              <span v-if="!$v.userInteraction.phone.numeric">El teléfono celular debe ser númerico</span>
              <span v-if="!$v.userInteraction.phone.minLength">El teléfono celular debe tener 10 dígitos</span>
              <span v-if="!$v.userInteraction.phone.maxLength">El teléfono celular debe tener 10 dígitos</span>
            </p>
          </div>
        </div>
        <div class="row">
          <div class="column">
            <button class="button float-right" @click.prevent="submit()">Siguiente</button>
          </div>
        </div>
        <div class="row">
          <div class="column box-errors">
            <p v-if="errors" class="error">El formulario tiene errores, por favor revísalos antes de seguir.
            </p>
            <p v-else-if="empty" class="error">El formulario está vacío, todos los campos son obligatorios.
            </p>
          </div>
        </div>
      </fieldset>
    </form>
  </div>

</template>

<script>

import StepIsPep from '@/views/userProfile/profileSteps/StepIsPep'
import StepIndirectPep from '@/views/userProfile/profileSteps/StepIndirectPep'

import { required, minLength, maxLength, alphaNum, numeric }
  from 'vuelidate/lib/validators'
import DatePicker from 'vuejs-datepicker'
import { es } from 'vuejs-datepicker/dist/locale'
import { format } from 'date-fns'
import Vue from 'vue'
import VueSweetalert2 from 'vue-sweetalert2'

import mixins from '@/mixins/index'
import userProfileMixin from '@/mixins/userProfileMixin'
import httpRequestMixin from '@/mixins/httpRequestMixin'

Vue.use(VueSweetalert2)

// eslint-disable-next-line no-useless-escape
const validateName = (field) => /^[a-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1\s]+$/.test((field))

export default {
  name: 'StepGeneralInfo',
  data () {
    return {
      endpointErrors: {
        name: false,
        middle_name: false,
        last_name: false,
        rfc: false,
        rfcTextError: null,
        curp: false,
        curpTextError: null,
        phone: false,
        married: false,
        birthdate: false,
        is_pep: false,
        gender: false,
        birthplace: false,
        nationality: false,
        birthplace_state: false
      },
      format,
      es: es,
      errors: false,
      empty: false,
      countries: [],
      states: [],
      stateStatus: false,
      genders: [],
      selectBooleanValues: [
        {
          civilStatus: 'Casado',
          pep: 'Si',
          value: true
        },
        {
          civilStatus: 'Soltero',
          pep: 'No',
          value: false
        }
      ],
      userInteraction: {
        name: null,
        middleName: null,
        lastName: null,
        birthDate: null,
        rfc: null,
        curp: null,
        phone: null,
        married: '',
        isPep: false,
        gender: '',
        birthCountry: '',
        birthEntity: '',
        nationality: ''
      },
      relativePep: '',
      dependantPep: '',
      generalInfoStatus: true,
      isPepStatus: false,
      dependantPepStatus: false,
      relativePepStatus: false
    }
  },
  validations: {
    userInteraction: {
      name: { required, minLength: minLength(2), validateName },
      middleName: { required, minLength: minLength(2), validateName },
      lastName: { required, minLength: minLength(2), validateName },
      birthDate: {
        required,
        adult (birthDate) {
          const userDate = new Date(birthDate)
          const newDate = Date.now() - userDate.getTime()
          const age = new Date(newDate)
          const finalAge = Math.abs(age.getUTCFullYear() - 1970)
          return (finalAge >= 18)
        },
        formattedDate (birthDate) {
          return (
            /^([0-2][0-9]|(3)[0-1])(-)(((0)[0-9])|((1)[0-2]))(-)\d{4}$/.test(
              this.dateFormat(birthDate))
          )
        },
        maxLength: maxLength(10)
      },
      birthCountry: { required },
      birthEntity: { required },
      nationality: { required },
      phone: {
        required,
        numeric,
        minLength: minLength(10),
        maxLength: maxLength(10)
      },
      rfc: {
        required,
        minLength: minLength(12),
        maxLength: maxLength(13),
        alphaNum,
        rfcCorrect (rfc) {
          return (
            /^([A-ZÑ&]{3,4})(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01]))([A-Z\d]{2})([A\d])$/.test(rfc)
          )
        }
      },
      curp: {
        required,
        minLength: minLength(18),
        maxLength: maxLength(18),
        alphaNum,
        curpCorrect (curp) {
          return (
            /^([A-Z][AEIOUX][A-Z]{2}\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])[HM](?:AS|B[CS]|C[CLMSH]|D[FG]|G[TR]|HG|JC|M[CNS]|N[ETL]|OC|PL|Q[TR]|S[PLR]|T[CSL]|VZ|YN|ZS)[B-DF-HJ-NP-TV-Z]{3}[A-Z\d])(\d)$/.test(curp)
          )
        }
      },
      gender: { required },
      married: { required }
    }
  },
  mixins: [mixins, userProfileMixin, httpRequestMixin],
  components: {
    StepIsPep,
    StepIndirectPep,
    DatePicker
  },
  methods: {
    getUserNames: async function () {
      await this.$store.dispatch('refreshToken')
      let options = {
        method: 'GET',
        url: process.env.AUTH_BASE + '/profile/',
        headers: {
          'Authorization': `Token ${this.$store.getters.getToken}`,
          'Content-Type': 'application/json'
        }
      }

      const response = await this.httpRequest(options)
      if (response) {
        this.userInteraction.name = response.data.name
        this.userInteraction.middleName = response.data.middle_name
        this.userInteraction.lastName = response.data.last_name
      }
    },
    sendDataToServer: async function () {
      let oldDate = this.dateFormat(this.userInteraction.birthDate)
      let newDate = this.reverseBirthDate(oldDate)

      let options = {
        method: 'PUT',
        url: process.env.AUTH_BASE + '/profile/legal/',
        headers: {
          'Authorization': `Token ${this.$store.getters.getToken}`,
          'Content-Type': 'application/json'
        },
        data: {
          name: this.userInteraction.name,
          middle_name: this.userInteraction.middleName,
          last_name: this.userInteraction.lastName,
          rfc: this.userInteraction.rfc,
          curp: this.userInteraction.curp,
          phone: this.userInteraction.phone,
          married: this.userInteraction.married,
          birthdate: newDate,
          is_pep: this.userInteraction.isPep,
          gender: this.userInteraction.gender,
          birthplace: this.userInteraction.birthCountry,
          nationality: this.userInteraction.nationality,
          birthplace_state: this.userInteraction.birthEntity === 33
            ? null
            : this.userInteraction.birthEntity
        }
      }
      const response = await this.httpRequest(options)
      if (response) {
        switch (response.status) {
          case 200:
          case 201:
            this.nextStep()
            break
          case 202:
            this.modalError(response.data.error, 'warning')
            break
          case 400:
            this.endpointErrors.name = ('name' in response.data)
            this.endpointErrors.middle_name = ('middle_name' in
              response.data)
            this.endpointErrors.last_name = ('last_name' in
              response.data)
            this.endpointErrors.rfc = ('rfc' in response.data)
            this.endpointErrors.rfcTextError = this.endpointErrors.rfc
              ? response.data['rfc'][0] : null
            this.endpointErrors.curp = ('curp' in response.data)
            this.endpointErrors.curpTextError = this.endpointErrors.curp
              ? response.data['curp'][0] : null
            this.endpointErrors.phone = ('phone' in response.data)
            this.endpointErrors.married = ('married' in response.data)
            this.endpointErrors.birthdate = ('birthdate' in
              response.data)
            this.endpointErrors.is_pep = ('is_pep' in response.data)
            this.endpointErrors.gender = ('gender' in response.data)
            this.endpointErrors.birthplace = ('birthplace' in
              response.data)
            this.endpointErrors.nationality = ('nationality' in
              response.data)
            this.endpointErrors.birthplace_state = ('birthplace_state' in
              response.data)
            break
          default:
            break
        }
      }
    },
    onChangeIsPep: function () {
      this.dependantPep = ''
      this.relativePep = ''
    },
    submit: function () {
      this.empty = !this.$v.userInteraction.$anyDirty
      this.errors = this.$v.userInteraction.$anyError

      if (!this.errors && !this.empty) {
        Vue.swal({
          type: 'info',
          title: '¡Aviso importante!',
          html: `El RFC que ingresaste es ` +
            `<strong>${this.userInteraction.rfc}</strong>, ` +
            `por favor verifica que sea correcto ya que es muy ` +
            `importante para validar tu cuenta.`,
          showCloseButton: true,
          showConfirmButton: true,
          showCancelButton: true,
          confirmButtonColor: '#00ba68',
          confirmButtonText: 'Es correcto mi RFC',
          cancelButtonText: 'Corregir mi RFC'
        }).then((result) => {
          if (result.value) {
            if (this.userInteraction.isPep) {
              this.generalInfoStatus = false
              this.isPepStatus = this.userInteraction.isPep
              this.doScroll(100)
            }
            if (this.relativePep) {
              this.generalInfoStatus = false
              this.relativePepStatus = this.relativePep
              this.doScroll(100)
            }
            if (this.dependantPep) {
              this.dependantPepStatus = this.dependantPep
            }
            this.sendDataToServer()
          }
        })
      }
    },
    onCountryChange: async function () {
      let options = {
        method: 'GET',
        url: process.env.AUTH_BASE + '/states/',
        params: {
          country: this.userInteraction.birthCountry
        },
        headers: {
          'Authorization': `Token ${this.$store.getters.getToken}`,
          'Content-Type': 'application/json'
        }
      }

      if (this.userInteraction.birthCountry === 148) {
        this.stateStatus = true
        this.userInteraction.birthEntity = ''

        const response = await this.httpRequest(options)
        if (response && response.status === 200) {
          this.states = response.data
        }
      } else {
        this.states = [
          {
            pk: 33,
            name: 'No aplica'
          }
        ]
        this.stateStatus = false
        this.userInteraction.birthEntity = 33
      }
    },
    getCountries: async function () {
      let options = {
        method: 'GET',
        url: process.env.AUTH_BASE + '/countries/',
        headers: {
          'Authorization': `Token ${this.$store.getters.getToken}`,
          'Content-Type': 'application/json'
        }
      }
      const response = await this.httpRequest(options)
      if (response && response.status === 200) {
        this.countries = response.data
      }
    },
    getGender: function () {
      // TODO GET géneros
      this.genders = [
        {
          pk: 1,
          name: 'Masculino'
        },
        {
          pk: 2,
          name: 'Femenino'
        }
      ]
    }
  },
  created: async function () {
    this.getGender()
    this.doScroll()
    await this.getCountries()
    await this.getUserNames()
  }
}

</script>

<style lang="scss" scoped>

.warning {
  margin-bottom: 1rem;

  > img {
    margin-right: 5px;
    margin-bottom: -4px;
  }
}

.rfc-message {
  margin-bottom: 1em;
  margin-top: -1em;
  color: $green;
  font-size: 12px;
}

</style>



// WEBPACK FOOTER //
// src/views/userProfile/profileSteps/StepGeneralInfo.vue